
function redirectToTruckPickup(callback) {
  if(confirm("Are you sure you want to change your order type? You may have to re-add any items to your cart.")){
    window.location.href = "https://trucktour.kinggrove.com/pages/truck-pickup"; 
  }
}

function redirectToFarmPickup(callback) {
  if(confirm("Are you sure you want to change your order type? You may have to re-add any items to your cart.")){
	window.location.href = "https://trucktour.kinggrove.com/pages/farm-pickup";
  }
}

function redirectToProducts(callback) {
  window.location.href = "https://shipmeblueberries.kinggrove.com/products"; 
}

function GetAppropriateAlertForHeader(e){
  var href = e.target.href;
  if(href.includes("tour-locations"))
  {
    e.preventDefault();
    redirectToTruckPickup();
  }
  if(href.includes("farm-pickup"))
  {
    e.preventDefault();
    redirectToFarmPickup();
  }
  if(href.includes("shipmeblueberries"))
  {
    //stay here
  }
}

(window.onpopstate = function() {
  // todo: add js alert to the 1st to li items, (add click even to the inner anchor)
})();
